import {ChangeDetectorRef, Component, TemplateRef, ViewChild} from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import {ToastrService} from "ngx-toastr";
import * as moment from "moment/moment";
import {TicketCustomFieldService} from "@appServices/core-ticketing/ticket-custom-field-service";
import {CustomFieldListRow} from "@appModels/ticketing/custom-field-list-row";

@Component({
  moduleId: module.id,
  templateUrl: './customfields-table.component.html',
  animations: [
    trigger('toggleAnimation', [
      transition(':enter', [style({ opacity: 0, transform: 'scale(0.95)' }), animate('100ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))]),
      transition(':leave', [animate('75ms', style({ opacity: 0, transform: 'scale(0.95)' }))]),
    ]),
  ],
  styleUrls: ['./customfields-table.component.css', '../../../tailwind.css']
})
export class CustomfieldsTableComponent {
  constructor(
    private toastrService: ToastrService,
    private ref: ChangeDetectorRef,
    private customFieldService: TicketCustomFieldService
  ) {
    this.getCustomFields();
  }

  loadingTable = true;
  dateFormat = moment().format('YYYY-MM-DD hh:mm:ss');
  moment: any = moment;

  getCustomFields() {
    this.customFieldService.getCustomFieldsListRow().subscribe(x=> {
      this.customFields = x;
      this.loadingTable = false;
    })
  }

  customFields : CustomFieldListRow[] = [];

}
